/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const syncNewPcrTests = /* GraphQL */ `
  query SyncNewPcrTests(
    $filter: ModelNewPcrTestFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncNewPcrTests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        indexNumber
        firstName
        middleName
        lastName
        personalId
        age
        complaints
        contacted
        payment
        previousTests
        testResult
        testDate
        resultDate
        sex
        comment
        published
        phoneNumber
        checkedOut
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getNewPcrTest = /* GraphQL */ `
  query GetNewPcrTest($id: ID!) {
    getNewPcrTest(id: $id) {
      id
      indexNumber
      firstName
      middleName
      lastName
      personalId
      age
      complaints
      contacted
      payment
      previousTests
      testResult
      testDate
      resultDate
      sex
      comment
      published
      phoneNumber
      checkedOut
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
    }
  }
`;
export const listNewPcrTests = /* GraphQL */ `
  query ListNewPcrTests(
    $filter: ModelNewPcrTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewPcrTests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        indexNumber
        firstName
        middleName
        lastName
        personalId
        age
        complaints
        contacted
        payment
        previousTests
        testResult
        testDate
        resultDate
        sex
        comment
        published
        phoneNumber
        checkedOut
        _version
        _deleted
        _lastChangedAt
        createdAt
        updatedAt
      }
      nextToken
      startedAt
    }
  }
`;
